const getAllowedListingFacets = (
  params: Record<string, unknown>,
  allowedParams: string[]
) => {
  if (!params || !allowedParams || typeof params !== 'object') return {};

  return Object.keys(params).reduce<Record<string, unknown>>(
    (acc, paramKey) => {
      if (allowedParams.includes(paramKey)) {
        return {
          ...acc,
          [paramKey]: params[paramKey],
        };
      }

      return acc;
    },
    {}
  );
};

export default getAllowedListingFacets;
